/**
 * Get file path for Firebase Storage
 * 
 * @param {string} fileName - File name
 * 
 * @returns {string} - File path
 * 
 */
const getFilePath = (fileName: string) => {
    // Get year
    const date = new Date();
    const year = date.getFullYear();
    // Get month
    const month = date.getMonth() + 1;
    // Get day
    const day = date.getDate();
    // Get time
    const time = date.getTime();

    // Get file extension
    const fileExtension = fileName.split(".").pop();
    // Get file name without extension
    const fileNameWithoutExtension = fileName.split(".").slice(0, -1).join(".");

    // Remove special characters from file name space, comma, etc change to -
    const fileNameWithoutSpecialCharacters = fileNameWithoutExtension.replace(/[^a-zA-Z0-9]/g, "-");

    return `${year}/${month}/${day}/${time}/${fileNameWithoutSpecialCharacters}.${fileExtension}`;
};

export default getFilePath;